<template>
  <div>
    <el-dialog
      :title="$t('lang.更换租客')"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <el-form
        :model="tenantForm"
        :rules="rules"
        ref="tenantForm"
        label-width="130px"
        :hide-required-asterisk="true"
      >
        <el-form-item :label="$t('lang.租客姓名')" prop="tenantName">
          <el-input
            v-model="tenantForm.tenantName"
            :placeholder="$t('lang.请输入租客姓名')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('lang.联系电话')"
          class="contactNumber"
          prop="tenantPhone"
        >
          <MyPopover ref="myPopoverRef" />
          <el-input
            v-model="tenantForm.tenantPhone"
            :placeholder="$t('lang.请输入联系电话')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("lang.取消") }}</el-button>
        <el-button type="primary" @click="onClickTenants" :loading="loading">
          {{ $t("lang.确定") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyPopover from "./my-popover.vue";
import { mapActions } from "vuex";
export default {
  components: { MyPopover },
  inject: ["equipmentPage"],
  data() {
    var tenantNameRule = (rule, value, callback) => {
      let reg = /(-|#|;|'|''|\\)|[\x00-\x1F]/gi;
      if (reg.test(value)) {
        callback(new Error(this.$t("lang.不能有特殊字符")));
      } else if (value.trim() == "") {
        callback(new Error(this.$t("lang.请输入租客姓名")));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      dialogVisible: false,
      tenantForm: {
        tenantName: "",
        tenantPhone: "",
        pointId: "",
        tenantAreaCode: "",
        selType: 1,
      },
      rules: {
        tenantName: [
          {
            required: true,
            validator: tenantNameRule,
            trigger: "blur",
          },
        ],
        tenantPhone: [
          {
            required: true,
            message: this.$t("lang.请输入联系电话"),
            trigger: "blur",
          },
        ],
      },
      dataDetail: {},
    };
  },
  mounted() {},
  methods: {
    ...mapActions({
      changeTenants: "ZD_ChangeTenants",
    }),
    handleClose() {
      this.dialogVisible = false;
      this.$refs.tenantForm.resetFields();
    },
    showDialog(data, selType) {
      this.dialogVisible = true;
      this.tenantForm.pointId = data.pointId;
      this.dataDetail = data;
      this.selType = selType;
    },
    async onClickTenants() {
      this.loading = true;
      this.tenantForm.tenantAreaCode = this.$refs.myPopoverRef.selAreaCode;
      try {
        await this.$refs.tenantForm.validate();
        this.tenantForm.tenantName = this.tenantForm.tenantName.trim();
        let res = await this.changeTenants({ value: this.tenantForm });
        if (res.success !== 1) return;
        this.handleClose();
        this.$message({
          message: this.$t("lang.更换租客成功"),
          type: "success",
        });
        this.$parent.refreshData();
        this.equipmentPage.$refs.rightDeviceRef.onClickQuery();
        if (this.selType == 2) {
          this.equipmentPage.$refs.rightDeviceRef.onClickDetails({
            pointId: this.tenantForm.pointId,
            deviceType: this.dataDetail.deviceType,
          });
        }
      } catch {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang='less'>
/deep/.el-dialog {
  width: 569px !important;
}
.el-form {
  padding-left: 30px;
}
.el-input {
  width: 300px;
}
/deep/.el-dialog__body {
  padding-bottom: 10px;
}
.contactNumber {
  position: relative;
  /deep/.el-input__inner {
    padding-left: 55px;
  }
}
</style>
